<template>
  <div class="about-us">
    <menuBox :step="5"></menuBox>
    <div class="about-title">
      <div class="sub-box">
        <input type="text" placeholder="你的名字" />
        <input type="text" placeholder="你的郵件" />
        <textarea class="message" type="text" placeholder="訊息" />
        <div class="btn" @click="submit()">預約</div>
      </div>
      <div class="contact-box">
        <p>Jason@superioralwayslimited.com</p>
        <p>E21, 10/F, 52 HUNG TO ROAD, KWUN TONG, KL</p>
        <p>00852+32254138</p>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.about-us {
  .about-title {
    background-image: url(../assets/contact-1.png);
    width: 100%;
    height: 880px;
    background-size: 100% 100%;
    overflow: hidden;
    .sub-box {
      width: 520px;
      height: 370px;
      padding: 40px;
      float: left;
      margin-left: 360px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
      margin-top: 270px;
      border-radius: 8px;
      input,
      textarea {
        background-color: #f5f5f5;
        width: 480px;
        padding: 0 20px;
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        height: 48px;
        border: none;
        margin-bottom: 20px;
      }
      .message {
        height: 120px;
        padding: 20px;
      }
      .btn {
        width: 100%;
        height: 56px;
        background: #53ba27;
        border-radius: 4px;
        line-height: 56px;
        font-size: 24px;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }
    }
    .contact-box {
      width: 285px;
      font-size: 18px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #333333;
      float: right;
      margin-right: 520px;
      margin-top: 400px;
      p{
        margin-bottom: 40px;
      }
    }
  }
}
</style>
